// extracted by mini-css-extract-plugin
export default {"text":"Intro_text__ytICA","container":"Intro_container__cr96b","gameTitle":"Intro_gameTitle__8Ompz","description":"Intro_description__QqaYq","superPower":"Intro_superPower__B+gRF"};